<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-virtualloby">
    <div class="header-custome">
      <div class="wrap-head">
        <h3>Virtual Lobby</h3>
        <p>Manage countdown timer, music and attendee welcome experience from this screen.</p>
      </div>
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-virtuallobby/question-1"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></span> Need help with this section?</a>
      </div>
    </div>
    <vx-card v-if="virtuallobby_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <!-- <div class="lobbyToggle" :data="lobbyType_data">
          <span v-if="CustomLobbyTag" class="lobbtTagText">Use CustomHtml Lobby</span>
          <span v-if="UseLobbyTag" class="lobbtTagText">Use Virtual lobby </span>
          <vs-switch v-model="LobbyType" @change="onLobbyTypeChange">
            <span slot="On" vs-value="2" name="lobbyHTML">On</span>
            <span slot="Off" vs-value="1" name="lobbyHTML">Off</span>
          </vs-switch>
        </div> -->
        <div class="lobbyToggle">
          <ul>
            <li :class="LobbyType == 1 ? 'active' : ''"><vs-radio name="LobbyType" vs-value="1" v-model="LobbyType" @change="onLobbyTypeChange">Default Lobby</vs-radio></li>
            <li :class="LobbyType == 2 ? 'active' : ''"><vs-radio name="LobbyType" vs-value="2" v-model="LobbyType" @change="onLobbyTypeChange">Custom Lobby</vs-radio></li>
          </ul>
        </div>

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Virtual Lobby" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <virtuallobby-edit-tab-account class="mt-4" :data="virtuallobby_data" />
            </div>
          </vs-tab>
          <vs-tab label="Custom HTML" icon-pack="feather" icon="icon-code">
            <div class="tab-text">
              <virtuallobby-image-hotspot class="mt-4" :data="virtuallobby_data" />
            </div>
          </vs-tab>
          
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>

import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"
var cn = ls.getSessionEventCollectionName();
const virtuallobbyRef = con.eventDB.collection(cn).doc('VirtualLobby');

const eventInfoRef = con.eventDB.collection(cn).doc('EventInfo')

import virtuallobbyEditTabAccount     from './VirtuallobbyEditTabAccount.vue'
import virtuallobbyImageHotspot     from './VirtuallobbyImageHotspot.vue'

// Store Module
import modulesvirtuallobbyManagementAdd from '@/store/virtuallobby-management/moduleVirtuallobbyManagement.js'
import Swal from 'sweetalert2';

var vm;
export default {
  components: {
    virtuallobbyEditTabAccount,
    virtuallobbyImageHotspot
    //attendeeEditTabInformation,
    //attendeeEditTabSocial    
  },
  data () {
    return {
      virtuallobby_data: null,
      virtuallobby_not_found: false,
      activeTab: 0,      
      lobbyType_data: null,
      LobbyType:1,
      CustomLobbyTag:false,
      UseLobbyTag:true
    }
  },
  watch: {
    activeTab () {
      this.fetch_virtuallobby_data()
    }
  },
  methods: {    
    fetch_virtuallobby_data () {
      this.$store.dispatch('virtuallobbyManagement/fetchVirtuallobby', virtuallobbyRef)
        .then(res => { this.virtuallobby_data = res.data })
        .catch(err => {          
          console.error(err)
        })
    },       
    onLobbyTypeChange:function(context, LobbyType) {  
      vm = this;
      console.log(this.LobbyType)
    if(this.LobbyType == 2){
             		const {
			value: text
		} = Swal.fire({
			title: 'Do you want to change the Virtual Lobby Type ?',
			input: 'text',
			inputPlaceholder: "Type 'yes' and hit the Submit button",
			showCancelButton: true,
			confirmButtonText: 'Submit',
			inputValidator: (value) => {
				if (value.toLocaleLowerCase() == 'yes') {
            LobbyType = 2;
            vm.activeTab = 1
            vm.CustomLobbyTag=false
            vm.UseLobbyTag=true
				} else {
					return "Try again! Please type 'yes' and hit Submit."
				}
			}
		}).then(function(result) {
      if(result.dismiss != null){
           vm.LobbyType = 1;
            LobbyType = 1;
      }else{
        vm.$store.dispatch('virtuallobbyManagement/updateLobbyType', LobbyType)
        .then(res => { 
          //alert(res.message) 
          if (res.status == 200) {
            // change Tab            
          }            
        }) 
        .catch(err => {     
        })
      }
     });
    }else{
        LobbyType = 1;
        vm.activeTab = 0
        //For Show hide
        vm.CustomLobbyTag=true
        vm.UseLobbyTag=false

         this.$store.dispatch('virtuallobbyManagement/updateLobbyType', LobbyType)
        .then(res => { 
          //alert(res.message) 
          if (res.status == 200) {
            // change Tab            
          }            
        }) 
        .catch(err => {     
        })
    }
    },

    fetchLobbyType(){
      return new Promise((resolve, reject) => {
        let docObj = new Object
        eventInfoRef.get().then(function (doc) { 
          var lobbyref = doc.data().LobbyType
          console.log(lobbyref)  
          vm.LobbyType=lobbyref        
          if(lobbyref == 1){
            //alert("2");
            //vm.LobbyType=true
            vm.activeTab= 0

            vm.CustomLobbyTag=false
            vm.UseLobbyTag=true
          }else{
            //alert("1");
            //vm.LobbyType=false
            vm.activeTab= 1 

            vm.CustomLobbyTag=true
            vm.UseLobbyTag=false
          }
        })
      })
    }    
    
  },
  mounted(){    
    vm = this
  },
  created () {
    // Register Module roundtableManagement Module
    if (!modulesvirtuallobbyManagementAdd.isRegistered) {
      this.$store.registerModule('virtuallobbyManagement', modulesvirtuallobbyManagementAdd)
      modulesvirtuallobbyManagementAdd.isRegistered = true
    }    
    this.fetch_virtuallobby_data(virtuallobbyRef);
    this.fetchLobbyType(eventInfoRef);
  }
}

</script>